(() => {
  'use strict';

  const init = root => {
    if (root.dataset.sampleViewerReady) return;
    const dialog = root.querySelector('[data-cw-sample-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const title = dialog.querySelector('[data-cw-sample-title]');
    const detail = dialog.querySelector('[data-cw-sample-detail]');
    const frame = dialog.querySelector('[data-cw-sample-frame]');
    const image = dialog.querySelector('[data-cw-sample-image]');
    const status = dialog.querySelector('[data-cw-sample-status]');
    const error = dialog.querySelector('[data-cw-sample-error]');
    const close = dialog.querySelector('[data-cw-sample-close]');
    if (![title, detail, frame, image, status, error, close].every(Boolean)) return;
    root.dataset.sampleViewerReady = 'true';

    let sequence = 0;
    let opener = null;
    let scrollStyles = null;

    const lockScroll = () => {
      if (scrollStyles) return;
      scrollStyles = [document.documentElement, document.body].map(element => ({
        element,
        value: element.style.getPropertyValue('overflow'),
        priority: element.style.getPropertyPriority('overflow')
      }));
      scrollStyles.forEach(({element}) => element.style.setProperty('overflow', 'hidden'));
    };

    const release = () => {
      sequence += 1;
      if (scrollStyles) {
        scrollStyles.forEach(({element, value, priority}) => {
          if (value) element.style.setProperty('overflow', value, priority);
          else element.style.removeProperty('overflow');
        });
        scrollStyles = null;
      }
      const target = opener;
      opener = null;
      if (target?.isConnected) target.focus({preventScroll: true});
    };

    const imageURL = source => {
      const url = new URL(source, location.href);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      const shopifyFile = url.pathname.startsWith('/cdn/shop/files/') ||
        (url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/'));
      if (shopifyFile && !/\.svg$/i.test(url.pathname)) url.searchParams.set('width', '1600');
      return url.href;
    };

    const open = trigger => {
      const option = trigger.closest('[data-cw-room-showcase]')
        ?.querySelector('[data-room-finish-select]')?.selectedOptions[0];
      const direct = Boolean(trigger.dataset.sampleUrl);
      const source = direct ? trigger.dataset.sampleUrl : option?.dataset.preview;
      if (!source) return;
      let url;
      try { url = imageURL(source); } catch { return; }
      if (!url) return;
      const name = direct ? trigger.dataset.sampleTitle : option.dataset.title || option.textContent;
      const prefix = direct ? '' : trigger.dataset.sampleStyleLabel;
      const description = direct ? trigger.dataset.sampleDetail : option.dataset.category;
      const sampleStyle = trigger.dataset.sampleStyle || '';
      const token = ++sequence;
      opener = trigger;
      title.textContent = prefix ? `${prefix} · ${name}` : name || '';
      detail.textContent = description || '';
      detail.hidden = !description;
      frame.style.cssText = sampleStyle;
      image.hidden = true;
      image.removeAttribute('src');
      image.alt = title.textContent;
      status.hidden = false;
      error.hidden = true;
      frame.setAttribute('aria-busy', 'true');
      if (!dialog.open) dialog.showModal();
      lockScroll();
      close.focus({preventScroll: true});

      const request = new Image();
      request.decoding = 'async';
      request.onload = () => {
        if (token !== sequence || !dialog.open) return;
        if (!sampleStyle && request.naturalWidth && request.naturalHeight) {
          frame.style.setProperty('--cw-sample-ratio', String(request.naturalWidth / request.naturalHeight));
        }
        image.src = url;
        image.hidden = false;
        status.hidden = true;
        frame.setAttribute('aria-busy', 'false');
      };
      request.onerror = () => {
        if (token !== sequence || !dialog.open) return;
        status.hidden = true;
        error.hidden = false;
        frame.setAttribute('aria-busy', 'false');
      };
      request.src = url;
    };

    root.addEventListener('click', event => {
      const trigger = event.target.closest('[data-cw-sample-open]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      open(trigger);
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { if (!dialog.open) release(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  };

  const start = () => document.querySelectorAll('.cw-web-cabinetry, .cw-sample-shop').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('castlewood:content-ready', start);
  document.addEventListener('shopify:section:load', start);
})();

